<div class="container">
  <div class="pt-5 mt-5 pb-5 mb-5">
    <div class="d-flex align-items-center justify-content-center w-100">
      <!-- <img src="assets/img/home.png" class="d-block img-fluid " alt="Bootstrap Themes" loading="lazy"> -->
    </div>
    <h4 class="text-center h4">Ops...</h4>
    <p class="text-center"> C'è stato un errore</p>
    <div class="text-center pb-3 mb-5">
      <button class="btn btn-primary" color="primary" (click)="reload()">
        Ricarica
      </button>
    </div>
  </div>
</div>
